import React from 'react';
import { Grid } from '@perxis-auto/ui-kit/lib/components/Grid';

import { ConstructorContext } from '@/context/constructor';
import { IPossibleConstructorGridItem } from '@/interfaces/constructor.interfaces';

import { CatalogGridProps } from './ConstructorGrid.types';

function ConstructorGrid({ grid, renderItem }: CatalogGridProps) {
  const { type } = grid;
  if (type) {
    const item = grid as IPossibleConstructorGridItem;
    return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      <ConstructorContext.Provider value={{ grid }}>
        {renderItem(item)}
      </ConstructorContext.Provider>
    );
  }
  return (
    <Grid
      grid={grid}
      renderItem={renderItem}
      renderGrid={grid => <ConstructorGrid grid={grid} renderItem={renderItem} />}
    />
  );
}

export default ConstructorGrid;
